import React from "react";
import Header from "./Header";
import Routing from "./Routes/Routing";
import Footer from "./Footer";

const Main = () => {
  return (
    <>
      <Header />
      <Routing />
      <Footer />
    </>
  );
};

export default Main;
